import { render, staticRenderFns } from "./Rect.vue?vue&type=template&id=15f3192a&scoped=true&"
import script from "./Rect.vue?vue&type=script&lang=ts&"
export * from "./Rect.vue?vue&type=script&lang=ts&"
import style0 from "./Rect.vue?vue&type=style&index=0&id=15f3192a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f3192a",
  null
  
)

export default component.exports